import { Vue, Options } from 'vue-class-component';
import { PropType } from 'vue';
import {
  EntrancePlantProRoles,
  EpUserRole,
} from '@/../client-generator/generated-clients/plants';
import { getUserInitialsForBubble } from '@/core/utils/utils';
import { mapState } from 'vuex';
import { AccountInfo } from '@azure/msal-browser';

@Options({
  name: 'UserEPItem',
  props: {
    user: {
      required: true,
      type: Object as PropType<EpUserRole>,
    },
    isMeBuildingAdmin: {
      type: Boolean,
    },
    totBuildingAdmins: {
      type: Number,
    },
    totDeviceManagers: {
      type: Number,
    },
  },
  emits: ['delete-user', 'revoke-building-admin'],
  computed: {
    ...mapState(['account']),
  },
})
export default class UserEPItem extends Vue {
  user!: EpUserRole;
  isMeBuildingAdmin!: boolean;
  totBuildingAdmins!: number;
  totDeviceManagers!: number;
  account!: AccountInfo;

  get userInitials() {
    return getUserInitialsForBubble(this.user);
  }

  get userRolesLabel() {
    const roles: string[] = [];
    const rolesLabel = [
      this.$t('AppResourceEP.DeviceManagerRole'),
      this.$t('AppResourceEP.BuildingAdminRole'),
    ];
    this.user.roles?.forEach((role) => {
      roles.push(rolesLabel[role]);
    });
    return roles.toLocaleString().replace(',', ', ');
  }

  get showRevokeBuildingAdmin() {
    return (
      this.user.roles!.length > 1 &&
      this.totBuildingAdmins > 1 &&
      this.isMeBuildingAdmin
    );
  }

  get showRemove() {
    let remainingBuildAdmins = this.totBuildingAdmins;
    let remainingDeviceManagers = this.totDeviceManagers;
    if (this.user.roles?.includes(EntrancePlantProRoles.BuildingManager))
      remainingBuildAdmins = this.totBuildingAdmins - 1;
    if (this.user.roles?.includes(EntrancePlantProRoles.DeviceManager))
      remainingDeviceManagers = this.totDeviceManagers - 1;

    return remainingBuildAdmins > 0 && remainingDeviceManagers > 0;
  }

  handleDeleteSharingUser() {
    this.$emit('delete-user', this.user);
  }

  handleRevokeBuildingAdmin() {
    this.$emit('revoke-building-admin', this.user);
  }
}
